import getUsedPaymentType from '../tracking/getUsedPaymentType';
import userAgent from '../utils/user-agent';
import getCategoriesFromProduct from './getCategoriesFromProduct';
import getProductIdForGTM from './getProductIdForGTM';
import getProductVariantIdForGTM from './getProductVariantIdForGTM';

export default () => {
  if (!window.dataLayer?.push) return 'fail';
  
  const {start} = window;
  const {order} = start;
  
  const getHomeDeliverySetUpStatus = (isHomeDeliverySetUp) => {
    if (isHomeDeliverySetUp == null) return '';
    return isHomeDeliverySetUp;
  };
  const getHomeDeliveryStockStatus = (homeDeliveryStockStatus) => {
    if (homeDeliveryStockStatus == null) return '';
    return homeDeliveryStockStatus ? 'in' : 'out';
  };
  
  const products = order.basketItems.map(basketItem => ({
    id: getProductIdForGTM(basketItem),
    name: basketItem.productTitle,
    brand: basketItem.brand || '',
    category: basketItem.category || '',
    quantity: basketItem.quantity,
    price: basketItem.chargePricePerUnit.value,
    pricePreDiscount: basketItem.itemPrice.value,
    linePrice: basketItem.totalChargePrice.value,
    currency: basketItem.itemPrice.currencyCode,
    dimension3: basketItem.fulfilmentMethod || '',
    dimension45: basketItem.storeCollectionTypeAvailable || '',
    dimension46: getHomeDeliverySetUpStatus(basketItem.isHomeDeliverySetUp),
    dimension48: getHomeDeliveryStockStatus(basketItem.homeDeliveryStockStatus),
    reviewsGroupingId: basketItem.reviewsGroupingId || '',
  }));
  
  const affiliation = order.basketItems.map(basketItem => basketItem.fulfilmentMethod);
  const uniqueAffiliations = affiliation.filter((item, pos) => affiliation.indexOf(item) === pos);
  
  const uniqueAffiliationsString = uniqueAffiliations.join(' | ');
  
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      purchase: {
        actionField: {
          action: 'checkout',
          step: 3,
          id: start.orderNumber,
          currency: start.orderTotal.currencyCode,
          totalDiscountExcludingFreeGifts: order.totalDiscountExcludingFreeGifts.value,
          revenue: start.orderTotal.value,
          shipping: order.totalShippingPrice.value,
          coupon: order.discountCode || '',
          affiliation: uniqueAffiliationsString,
          order_id: start.orderNumber,
          adjustment_type: 'ENHANCEMENT',
          user_agent: userAgent.getUserAgent(),
          restatement_value: {
            adjusted_value: order.totalPriceOfItems.value,
            currency_code: start.orderTotal.currencyCode,
          },
          usedPaymentMethod: getUsedPaymentType(),
        },
        products,
      },
    },
  });
  if (start.settings?.ga4_data_layer_enabled === true) {
    window.dataLayer.push({
      event: 'ga4_purchase',
      ecommerce: {
        transaction_id: start.orderNumber,
        value: start.orderTotal.value,
        tax: '',
        shipping: order.totalShippingPrice.value,
        currency: start.orderTotal.currencyCode,
        coupon: order.discountCode || '',
        items: order.basketItems.map(basketItem => ({
          item_id: getProductIdForGTM(basketItem),
          ...getCategoriesFromProduct(basketItem),
          item_name: basketItem.productTitle,
          index: '',
          item_brand: basketItem.brand || '',
          item_list_id: '',
          item_list_name: '',
          item_variant: getProductVariantIdForGTM(basketItem),
          price: basketItem.chargePricePerUnit.value,
          quantity: basketItem.quantity,
        })),
      },
    });
  }
  return 'success';
};
